import { useTranslation } from "react-i18next";

interface PaymentsNoticeProps {
  className?: string;
}

export default function PaymentsNotice({ className = "" }: PaymentsNoticeProps) {
  const { t } = useTranslation();

  return (
    <div className={`mt-4 p-3 bg-blue-50 rounded-md border border-blue-100 ${className}`}>
      <div className="flex items-start space-x-2">
        <div className="text-blue-500 mt-0.5">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div>
          <p className="text-sm text-blue-700">
            {t("bookings.form.confirmation.payment_note")}
          </p>
          <a
            href="/settings?activeTab=payments"
            target="_blank"
            className="text-sm flex items-center space-x-1 mt-2 bg-blue-100 text-blue-700 hover:bg-blue-200 px-3 py-1.5 rounded-md font-medium transition-colors inline-flex border border-blue-200"
          >
            <span>{t("bookings.form.confirmation.payment_settings_link")}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}


